import { computed } from "vue";
import { useRouter } from "vue-router/composables";

import useLegacyStore from "@Composables/useLegacyStore";
import useTranslation from "@Composables/useTranslation";
import useNotify from "@Composables/useNotify";
import { closeStaticPopover } from "@Helpers/functions/closePopover";

export const ALIAS_BEHIND_MINIMUM = "Must be at least 5 characters";
export const ALIAS_BRANDED_BEHIND_MINIMUM = "Must be at least 1 characters";

export default function useShortenerForm() {
  const { getters } = useLegacyStore();
  const { notifyError } = useNotify();
  const router = useRouter();
  const { __ } = useTranslation();

  const availableDomains = computed(() => getters.availableDomains);
  const commonDomains = computed(() => getters.commonDomains);
  const canUseBrandedDomains = computed(() => getters.canUseBrandedDomains);

  const allowedAvailableDomains = computed(() => {
    function filterAvailableDomains(domain) {
      return !domain.isDisabled && !domain.isDeleted && !domain.isBlocked;
    }

    function sortDomainAlphabetically(a, b) {
      return a.domain > b.domain ? 1 : b.domain > a.domain ? -1 : 0;
    }

    return availableDomains.value
      .filter(filterAvailableDomains)
      .sort(sortDomainAlphabetically);
  });

  function addDomain() {
    closeStaticPopover();

    if (!canUseBrandedDomains.value) {
      notifyError({ text: __("billing.not_subscribed") });
      router.push({ name: "settings.subscription" });
    } else {
      router.push({ name: "settings.brandedDomains" });
    }
  }

  function defaultDomain() {
    const domainData = allowedAvailableDomains.value.find((domain) => {
      return domain.domain === commonDomains.value.current;
    });

    if (domainData) {
      return domainData.domain;
    } else {
      return window.location.hostname;
    }
  }

  return {
    allowedAvailableDomains,
    addDomain,
    defaultDomain,
  };
}
